module.exports = __webpack_public_path__ + "static/ups_store_creekside-5df9fc7f300f90f95b22bf9730a740f8.png";